import objectFitImages from 'object-fit-images';
import svg4everybody from 'svg4everybody';
import '@crasman/branch-bar/styles.css';
import { branchBar } from '@crasman/branch-bar';

import CookieDialog from './modules/cookie-dialog';
import loadMore from './modules/load-more';
import polyfills from './modules/polyfills';
import navigation from './modules/navigation';
import headerSearch from './modules/header-search';
import cookieConsent from './modules/cookie-consent';
import chartModals from './modules/chart-modals';
import contentFiltering from './modules/content-filtering';
import multiselect from './modules/multiselect';
import SummaryToc from './modules/summary-toc';
import PDFList from './modules/pdf-list';

// Legacy (these should be refactored)
import reel from './legacy/reel';
import article from './legacy/article';
import offcanvas from './legacy/offcanvas-toggle-class';
import main from './legacy/main2';
import basket from './legacy/basket';

// Init everything on domready
document.addEventListener('DOMContentLoaded', function() {
  branchBar.init();
  polyfills.init();
  navigation.init();
  headerSearch.init();
  cookieConsent.init();
  loadMore.init();
  chartModals.init();
  contentFiltering.init();
  multiselect.init();
  SummaryToc.init('.js-summary-toc');
  PDFList.init('.js-pdf-list');

  objectFitImages();
  svg4everybody();

  const cookieDialogElement = document.getElementById('cookie-dialog');
  if (cookieDialogElement) {
    new CookieDialog(cookieDialogElement);
  }

  // Legacy
  reel.init();
  article.init();
  offcanvas.init();
  main.init();
  basket.init();
});
